/* eslint-disable no-redeclare */
import Vue from 'vue'
import Router from 'vue-router'

// Layouts
import LayoutDefault from './layouts/default'
import LayoutBlank from './layouts/blank'

/////////////////////////

/////////////////////
////////
/////////////////////////////////////
///////////////////////////////////////
///////////////////////////////////////
///////////////////////////////////
///////////////////////////////////////////////////
/////////////////////////////////////////////
/////////////////////////////////////
/////////////////////////////////////////////
///////////////////////////////////////////
//////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////

/////////

// Lazy Routes
const PageLogin = () => import(/* webpackChunkName: "login" */ './pages/login.vue')
// const PageHome = () => import(/* webpackChunkName: "index" */ './pages/index.vue')
const PageSearch = () => import(/* webpackChunkName: "search" */ './pages/search.vue')
const PagePack = () => import(/* webpackChunkName: "pack" */ './pages/pack.vue')
const PageContributors = () => import(/* webpackChunkName: "contributors" */ './pages/contributors.vue')
const PageDownloads = () => import(/* webpackChunkName: "downloads" */ './pages/downloads.vue')
const PageLikes = () => import(/* webpackChunkName: "likes" */ './pages/likes.vue')
const PagePrototype = () => import(/* webpackChunkName: "prototype" */ './pages/prototype.vue')
const PageSettings = () => import(/* webpackChunkName: "settings" */ './pages/settings.vue')
const PageSettingsAccount = () => import(/* webpackChunkName: "settings-account" */ './pages/settings/account.vue')
const PageAccountSwitch = () => import(/* webpackChunkName: "settings-account/switch" */ './pages/settings/account/switch.vue')
const PageSettingsPlugin = () => import(/* webpackChunkName: "settings-plugin" */ './pages/settings/plugin.vue')

//////////

Vue.use(Router)

export default new Router({
  // Abstract mode stores the path in memory,
  // This allows us to use url-hash to communicate with the parent wrapper
  // Such as, Sketch, Adobe, Microsoft, GSuite, etc.
  mode: (process.env.VUE_APP_PLATFORM === 'xd' || process.env.VUE_APP_PLATFORM === 'office') ? 'abstract' : 'hash',
  // mode: 'abstract',
  // mode: 'history',

  // All the routes goes here
  routes: [
    {
      path: 'login',
      name: 'login',
      component: PageLogin
    },
    {
      path: '/',
      component: LayoutDefault,

      children: [
        {
          path: '/icons/:slug?',
          name: 'icons-slug',
          component: PageSearch
        },
        {
          path: '/illustrations/:slug?',
          name: 'illustrations-slug',
          component: PageSearch
        },
        {
          path: '/photos/:slug?',
          name: 'photos-slug',
          component: PageSearch
        },
        {
          path: 'pack/:slug',
          name: 'pack-slug',
          component: PagePack
        },
        {
          path: 'prototype',
          name: 'prototype',
          component: PagePrototype
        },
        {
          path: 'downloads',
          name: 'downloads',
          component: PageDownloads
        },
        {
          path: 'likes',
          name: 'likes',
          component: PageLikes
        },
        {
          path: 'settings',
          component: PageSettings,

          children: [
            {
              path: 'account',
              name: 'settings-account',
              component: PageSettingsAccount,

              children: [
                {
                  path: 'switch/:type/:uuid',
                  name: 'settings-account-switch',
                  component: PageAccountSwitch
                }
              ]
            },
            {
              path: 'plugin',
              name: 'settings-plugin',
              component: PageSettingsPlugin
            }
          ]
        }
      ]
    },
    {
      path: '/',
      component: LayoutBlank,

      children: [
        {
          path: '/contributors',
          name: 'contributors',
          component: PageContributors
        }
      ]
    }
  ]
})
